const moneyNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const statusKey = (value) => {
  const raw = String(value || '').trim().toUpperCase();
  if (raw === 'PENDING LIVE') return 'PENDING_LIVE';
  if (raw === 'PENDING CANCEL') return 'PENDING_CANCEL';
  if (raw === 'CANCELED') return 'CANCELLED';
  return raw || 'LIVE';
};

export const dpeActionPrice = (action = {}) => moneyNumber(
  action.vmtPayload?.dealerPrice
  ?? action.dealerPrice
  ?? action.sourceEvidence?.dealerPrice
  ?? action.sourceEvidence?.mrr
  ?? action.sourceEvidence?.price
);

export const dpeActionSourceStatus = (action = {}) => statusKey(
  action.sourceEvidence?.productStatus
  || action.sourceEvidence?.status
  || action.previousProductStatus
  || action.previousStatus
);

export const dpeActionTargetStatus = (action = {}) => statusKey(
  action.productStatus
  || action.vmtPayload?.status
  || action.status
);

export const dpeActionProductCode = (action = {}) => (
  action.productCd
  || action.vmtPayload?.productCd
  || action.sourceEvidence?.productCode
  || action.sourceEvidence?.productCd
  || ''
);

export const dpeActionProductName = (action = {}) => (
  action.productDescription
  || action.vmtPayload?.productDescription
  || action.sourceEvidence?.productName
  || action.sourceEvidence?.productDescription
  || dpeActionProductCode(action)
);

export const actionStillAffectsDpePreview = (action = {}) => {
  const status = String(action.queueStatus || 'draft').toLowerCase();
  return ['draft', 'inherited_pending', 'saved', 'sending', 'error'].includes(status);
};

export const dpeActionMatchesStatus = (action = {}, activeStatus = 'LIVE') => {
  const active = statusKey(activeStatus);
  if (action.actionType === 'remove') {
    return dpeActionSourceStatus(action) === active || dpeActionTargetStatus(action) === active;
  }
  return dpeActionTargetStatus(action) === active;
};

export const adjustedDpeTotalForStatus = ({ baseTotal = 0, dpeActions = [], activeStatus = 'LIVE' } = {}) => {
  const active = statusKey(activeStatus);
  return dpeActions
    .filter(actionStillAffectsDpePreview)
    .reduce((sum, action) => {
      const price = dpeActionPrice(action);
      if (action.actionType === 'remove') {
        const sourceStatus = dpeActionSourceStatus(action);
        const targetStatus = dpeActionTargetStatus(action);
        const removeDelta = sourceStatus === active ? -price : 0;
        const addDelta = targetStatus === active ? price : 0;
        return sum + removeDelta + addDelta;
      }
      if (action.actionType === 'change_price') {
        const targetStatus = dpeActionTargetStatus(action);
        const sourceStatus = dpeActionSourceStatus(action) || targetStatus;
        const previousPrice = moneyNumber(action.sourceEvidence?.dealerPrice ?? action.sourceEvidence?.mrr ?? action.previousDealerPrice);
        const removeDelta = sourceStatus === active ? -previousPrice : 0;
        const addDelta = targetStatus === active ? price : 0;
        return sum + removeDelta + addDelta;
      }
      return dpeActionTargetStatus(action) === active ? sum + price : sum;
    }, moneyNumber(baseTotal));
};
